import { HStack, VStack, Heading, Button } from '@chakra-ui/react';
import { useTheme } from '../../../contexts/ThemeProvider';
import { Text } from '../../../components/atoms/Text';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { INotification } from '@partiu/api/notifications/types';

export function CardNotification({ date, onHandleClick, discount, pushBody, pushSubject }: INotification) {
  const { colors } = useTheme();

  const formattedDate = format(new Date(date), 'dd MMM yyyy', { locale: ptBR });

  return (
    <HStack
      alignItems={'flex-start'}
      spacing={2}
      boxShadow={'4px 4px 10px 0px #0000002E'}
      padding={'20px'}
      width={'100%'}
      borderRadius={'20px'}
      backgroundColor="white"
    >
      <VStack width="100%">
        <HStack width="100%" justifyContent={'space-between'} alignItems={'flex-start'}>
          <Heading noOfLines={2} flex={'1'} fontSize={'18px'}>
            {pushSubject}
          </Heading>
          <Text fontSize={'14px'} color={colors.primaryColor}>
            {formattedDate}
          </Text>
        </HStack>
        <Text width="100%" textAlign={'start'} color="black" fontSize={11} fontWeight={400}>
          {pushBody}
        </Text>
        {discount && onHandleClick && (
          <Button marginLeft={'auto'} size={'xs'} onClick={onHandleClick} variant={'unset'} color={colors.primaryColor}>
            Ver desconto
          </Button>
        )}
      </VStack>
    </HStack>
  );
}
